import { useState } from "react";

import { useCreateVectorStore } from "@/queries/vector-store";
import { displayToast, displayErrorToast } from "@/utils/toast";
import { ToastType } from "@/enums";

interface UseStoreCreationProps {
  onStoreCreated?: (storeId: string) => void;
}

export const useStoreCreation = ({ onStoreCreated }: UseStoreCreationProps = {}) => {
  const [isCreating, setIsCreating] = useState(false);
  const [newStoreName, setNewStoreName] = useState("");

  const { mutate: createVectorStore, isLoading: isCreatingStore } = useCreateVectorStore();

  const handleCreateStore = () => {
    if (!newStoreName.trim()) {
      displayErrorToast("Please enter a store name");
      return;
    }

    createVectorStore(
      { name: newStoreName },
      {
        onSuccess: data => {
          displayToast("Vector store created successfully", ToastType.success);
          setIsCreating(false);
          setNewStoreName("");

          // Call the callback with the new store's ID if provided
          if (onStoreCreated && data?.vector_store?.id) {
            onStoreCreated(data.vector_store.id);
          }
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onError: (error: any) => {
          displayErrorToast(error?.message || "Failed to create vector store");
        },
      },
    );
  };

  const handleCancelCreation = () => {
    setIsCreating(false);
    setNewStoreName("");
  };

  return {
    isCreating,
    setIsCreating,
    newStoreName,
    setNewStoreName,
    isCreatingStore,
    handleCreateStore,
    handleCancelCreation,
  };
};
